import React from "react";
import s from "./style.module.scss";
import { SetState } from "shared/types/general";
import Check from "features/Auth/ConfirmCodeForm/icons/Check";

interface CheckboxProps {
  checked: boolean;
  setChecked: SetState<boolean>;
  id: string;
  label: string | React.ReactNode;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  label,
  setChecked,
  id,
}) => {
  const handleChange = () => {
    setChecked(!checked);
  };

  return (
    <div className={`${s.checkbox} ${checked ? s.checked : ""}`}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
      />
      <label htmlFor={id}>{label}</label>

      <Check />
    </div>
  );
};

export default Checkbox;
